<template>
  <div class="loadingio-spinner-eclipse-icnwarosjiq">
    <div class="ldio-v8iuis3k5a">
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheLoader',
};
</script>

<style scoped>
@keyframes ldio-v8iuis3k5a {
  0% {
    transform: rotate(0deg)
  }
  50% {
    transform: rotate(180deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

.ldio-v8iuis3k5a div {
  position: absolute;
  animation: ldio-v8iuis3k5a 1s linear infinite;
  width: 160px;
  height: 160px;
  top: 20px;
  left: 20px;
  border-radius: 50%;
  box-shadow: 0 4px 0 0 #109ceb;
  transform-origin: 80px 82px;
}

.loadingio-spinner-eclipse-icnwarosjiq {
  display: block;
  width: 200px;
  height: 200px;
  overflow: hidden;
  background-color: #ffffff;
  margin: 0 auto;
}

.ldio-v8iuis3k5a {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}

.ldio-v8iuis3k5a div {
  box-sizing: content-box;
}

/* generated by https://loading.io/ */
</style>
